// extracted by mini-css-extract-plugin
export default {"root":"DarkThemeButton_root__jYn1s"};